import React from 'react'
import { css } from '@emotion/css'
import { useIntl } from 'react-intl'
import {
  Menu,
  MenuItem,
  MenuTrigger,
  PopoverMenu
} from '@contrast-security-inc/design-system-popovers'
import {
  IconDropdownCollapse,
  IconDropdownExpand
} from '@contrast-security-inc/design-system-foundations'
import { Stack } from '@contrast-security-inc/design-system-layouts'
import {
  LibraryStatus,
  defaultLibraryStatusRegistry
} from '../cell-content/status-cell'

interface Props {
  readonly updateStatuses: (status: LibraryStatus) => void
  readonly menuPlacement: 'top' | 'bottom'
}

export function UpdateStatusAction({ menuPlacement, updateStatuses }: Props) {
  const { formatMessage } = useIntl()

  return (
    <PopoverMenu placement={menuPlacement}>
      <Menu>
        {defaultLibraryStatusRegistry.all.map((status) => (
          <MenuItem
            key={status.name}
            itemID={status.name}
            onClick={() => updateStatuses(status)}
          >
            {formatMessage({ id: status.i18nID })}
          </MenuItem>
        ))}
      </Menu>
      <MenuTrigger>
        {({ isOpen }) => (
          <Stack
            justifyContent="center"
            alignItems="center"
            testId="update-status-action"
          >
            <span
              className={css`
                margin-right: -12px;
              `}
            >
              {formatMessage({ id: 'title_status' })}
            </span>
            {isOpen ? <IconDropdownCollapse /> : <IconDropdownExpand />}
          </Stack>
        )}
      </MenuTrigger>
    </PopoverMenu>
  )
}
